export default __webpack_public_path__ + "static/media/home-digital-agency-bg-img-01.f5789577.jpg";